// extracted by mini-css-extract-plugin
module.exports = {"add":"NavBar_add__G22aw","paw":"NavBar_paw__3Zfqp","home":"NavBar_home__2zNOv","nav":"NavBar_nav__majFo","doggy":"NavBar_doggy__1oKRp"};